import { useEffect } from 'react'
import styled from '@emotion/styled'
import { mediaQueries } from '@resiliatech/birdsong'
import { Dialog, IconButton } from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close'
import { analytics } from 'Modules/Analytics'
import { upgrade } from 'Modules/Analytics/trackActionInterface/Account/upgrade'
import StaticPopupModal from 'Components/SharedComponents/StaticPopupModal/StaticPopupModal'
import { UpgradeSell } from '../UpgradeSell/UpgradeSell'

const UpgradeDialogContainer = styled(Dialog)`
  & .MuiDialog-paper {
    margin: 0;
    padding: 24px;
    min-width: 0;
    text-align: center;
    position: relative;

    @media ${mediaQueries.small.down} {
      min-width: 100%;
      border-radius: 0;
      height: 100%;
      max-height: 100%;
      padding: 0 5px;
    }
  }

  & .MuiDialogContent-root {
    @media ${mediaQueries.small.down} {
      overflow-y: initial;
    }
  }
`

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;

  @media ${mediaQueries.small.down} {
    position: fixed;
    right: 0;
    top: -5px;
    padding-right: 2px;
  }
`

export const UpgradeModal = ({
  openUpgradeDialog,
  setOpenUpgradeDialog,
  hideBackdrop = false,
}: {
  openUpgradeDialog?: boolean
  setOpenUpgradeDialog?: (value: boolean) => void
  hideBackdrop?: boolean
}) => {
  const isFixed =
    openUpgradeDialog === undefined || setOpenUpgradeDialog === undefined

  useEffect(() => {
    if (openUpgradeDialog || isFixed) {
      analytics.trackActionCreator(upgrade.Modal_Viewed)({})
    }
  }, [openUpgradeDialog, isFixed])

  if (isFixed) {
    return (
      <StaticPopupModal
        withCloseIcon={false}
        withBackdrop={!hideBackdrop}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        backdropClickHandler={() => {}}
        showAppBarWithBackdrop
        containerStyle={{ maxWidth: '680px' }}
        hideButton
      >
        <UpgradeSell />
      </StaticPopupModal>
    )
  }

  return (
    <UpgradeDialogContainer
      open={openUpgradeDialog}
      onClose={() => setOpenUpgradeDialog(false)}
    >
      <CloseButton onClick={() => setOpenUpgradeDialog(false)}>
        <CloseIcon />
      </CloseButton>
      <UpgradeSell handleExit={() => setOpenUpgradeDialog(false)} />
    </UpgradeDialogContainer>
  )
}
